import { Text } from "~/components/Text";

type Insight = {
  id: string;
  answer: string;
  visible: boolean;
};

type InsightsListProps = {
  insights: Insight[];
};

export function InsightsList({ insights }: InsightsListProps) {
  const visible = insights.filter(
    (i) => i.visible && i.answer.trim().length > 0,
  );
  if (visible.length === 0) return null;

  return (
    <ul className="flex flex-col gap-2">
      {visible.map((insight) => (
        <li
          key={insight.id}
          className="flex items-center gap-3 rounded-lg border border-butter-cream bg-white/80 p-4"
        >
          <span
            aria-hidden
            className="h-2 w-2 flex-shrink-0 rounded-full bg-butter-pink"
          />
          <Text as="span" variant="secondary" size="md" className="leading-snug">
            {insight.answer}
          </Text>
        </li>
      ))}
    </ul>
  );
}
